import React, { } from 'react'

import { FormattedMessage } from 'react-intl'
import Card from 'components/Card'
import CreateIcon from 'icons/CreateIcon'
import styles from './GroupsPage.css'
import {
  AppComponentsContextProvider,
  MyCirclesList, MyCirclesPage,
} from 'lib-core'
import styled from 'styled-components'
import { NoSsr } from '@material-ui/core'

import ErrorPanel from 'components/ErrorPanel'
import PleaseWait from 'components/PleaseWait'
import { ReactFC } from 'lib-core/dist/types'
import { useDispatch } from 'react-redux'
import { createGroupOptions } from './create/basics/CreateGroupBasicsPage'
import { Link } from 'react-router-dom'


const CircleList = styled.div`
  padding-bottom: 30vh;
  background-color: #F0F2F5;
  overflow: hidden;
`


export const CreateCircleLink: ReactFC = () => {
  const dispatch = useDispatch()
  const onCreate = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    event.preventDefault()
    createGroupOptions({ parent: undefined })
    dispatch({ type: "groups/_create/basics" })
  }
  return (
    <Link to={"/groups/_create"} className="mx-1 sm:mx-2" onClick={onCreate}>
      <div className="text-primary font-semibold text-xs sm:text-xl p-1">
        <FormattedMessage id="common.create" />
      </div>
    </Link>
  )
}


const GroupsHomePage = () => {
  return (
    <AppComponentsContextProvider CreateCircleComponent={CreateCircleLink}>
      <CircleList>
        <NoSsr>
          <MyCirclesPage />
        </NoSsr>
      </CircleList>
    </AppComponentsContextProvider>
  )
}

export default GroupsHomePage
